import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Crypto } from '@zero/crypto/domain';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { NgArrayPipesModule } from 'ngx-pipes';
import { CryptoListItemComponent } from '../crypto-list-item/crypto-list-item.component';

export type CryptoList = 'CRYPTOS' | 'ETPS' | null;

@Component({
  selector: 'crypto-crypto-list',
  templateUrl: './crypto-list.component.html',
  styleUrls: ['./crypto-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CryptoListItemComponent, TranslocoPipe, NgArrayPipesModule, ButtonComponent],
})
export class CryptoListComponent {
  @Input() public popularCryptos: Crypto[];
  @Input() public cryptos: Crypto[];

  @Output() public scrollTo = new EventEmitter<CryptoList>();
}
